import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-highlight-list',
  templateUrl: './highlight-list.component.html',
  styleUrls: ['./highlight-list.component.scss']
})
export class HighlightListComponent implements OnInit {
  static ALL_VALUE = 'All';
  static SPECIAL_OFFERS_URL_PART = 'special-offers';
  @Input() data;
  public menuList: Array<string> = [];
  public detailExpander: { isOpen: boolean; page: string } = {
    isOpen: false,
    page: null
  };
  public listBlocks: Array<string> = [];
  public selectedItem: string;
  public isLevelMenuVisibe = false;
  public backgroundColor: string;
  public isLeftAligned = true;
  public callToActionTitle: string;
  public titleColor: string;

  constructor() {}

  ngOnInit() {
    this.listBlocks = this.data.highlight_blocks;
    this.isLevelMenuVisibe = this.data.show_menu;
    this.backgroundColor = this.data.background_color
      ? this.data.background_color
      : null;
    this.titleColor = this.data.title_color ? this.data.title_color : null;
    this.isLeftAligned = this.data.is_left_aligned;
    this.callToActionTitle = this.data.call_to_action_title;

    this.generateMenuAndApplyFilters();

    /**
    To proper working filters if we clicking on footer page type links when already on special offers page, we must to listen   hashchange event, because there is to page reloading in this case
     */
    if (
      window.location.pathname.indexOf(
        HighlightListComponent.SPECIAL_OFFERS_URL_PART
      ) !== -1
    ) {
      window.addEventListener('hashchange', () => {
        this.generateMenuAndApplyFilters();
        const element: HTMLElement = document.querySelector('.level-menu');

        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  /**
   * Extracts anchor from URL and try to apply it as filter to constucted menu
   */
  generateMenuAndApplyFilters() {
    const menuAnchor = decodeURIComponent(window.location.hash).replace(
      '#',
      ''
    );
    this.menuList = this.getGeneratedMenu(this.data.page_types);
    this.setDefaultMenuFilter(menuAnchor, this.menuList);
  }

  /**
   * Select default menu item if anchor is present, or default value if not
   *
   */
  setDefaultMenuFilter(menuAnchor: string | null, menuList: any[]) {
    if (menuAnchor) {
      const index = menuList.indexOf(menuAnchor);

      if (index !== -1) {
        this.onMenuClick(menuAnchor);
      } else {
        this.onMenuClick(HighlightListComponent.ALL_VALUE);
      }
    } else {
      this.onMenuClick(HighlightListComponent.ALL_VALUE);
    }
  }

  toggleExpander(page) {
    if (page) {
      this.detailExpander = { isOpen: true, page: page };
    } else {
      this.detailExpander = { isOpen: false, page: null };
    }
  }

  getGeneratedMenu(pageTypes: any[]): string[] {
    pageTypes.sort(function(a, b) {
      if (a.weight > b.weight) {
        return 1;
      }
      if (b.weight > a.weight) {
        return -1;
      }
      return 0;
    });
    return pageTypes.map(value => value.name);
  }

  onMenuClick(item: string) {
    this.selectedItem = item;
    this.applyAnchor(item);
  }

  isMenuItemActive(item: string) {
    return this.selectedItem === item;
  }

  getLeftAlignedClass() {
    return this.isLeftAligned ? 'left-align' : '';
  }

  applyAnchor(item: string) {
    const anchorName = item;

    window.history.pushState(
      '',
      document.title,
      window.location.href.split('#')[0] + '#' + encodeURIComponent(anchorName)
    );
  }
}
